import { cn } from '@/lib/utils';
import type { RefObject } from 'react';
import { useCallback } from 'react';

interface ScrollableImageIndicatorProps {
  total: number;
  current: number;
  scrollContainerRef?: RefObject<HTMLElement | null>;
  itemWidth?: number;
  className?: string;
  activeClassName?: string;
  inactiveClassName?: string;
}

export function ScrollableImageIndicator({
  total,
  current,
  scrollContainerRef,
  itemWidth,
  className,
  activeClassName = "bg-pastel-purple w-2 h-2",
  inactiveClassName = "bg-gray-300 hover:bg-gray-400 w-2 hover:scale-110"
}: ScrollableImageIndicatorProps) {

  const scrollToIndex = useCallback((index: number) => {
    if (!scrollContainerRef?.current) return;

    // itemWidthが提供されていない場合は、コンテナの幅から計算
    const containerWidth = scrollContainerRef.current.scrollWidth;
    const calculatedItemWidth = itemWidth || (containerWidth / total);
    const targetScroll = calculatedItemWidth * index;

    scrollContainerRef.current.scrollTo({
      left: targetScroll,
      behavior: 'smooth'
    });
  }, [scrollContainerRef, itemWidth, total]);

  return (
    <div className={cn("flex gap-1.5", className)}>
      {Array.from({ length: total }).map((_, index) => (
        <button
          key={index}
          onClick={() => scrollToIndex(index)}
          className={cn(
            "h-2 rounded-full transition-all duration-300",
            index === current
              ? activeClassName
              : inactiveClassName
          )}
          aria-label={`画像${index + 1}へ移動`}
        />
      ))}
    </div>
  );
}
